export default __webpack_public_path__ + "static/media/icon-questionmark.7a44f6a5.svg";